import React from 'react';
import { ContextualMenuSelect } from '../../ContextualMenu/Select';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { useInput } from '../../../machines/inputMachine/useInput';
import { Label } from '../../Label';
import { Stack } from '../../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ContextualMenuSelectControl = props => {
  var _props$label;
  if (!props.inputService) return /*#__PURE__*/_jsx("div", {
    children: "no input service defined"
  });
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(props.inputService);
  const handleChange = newItems => {
    send([{
      type: 'FOCUS'
    }, {
      type: 'CHANGE',
      value: newItems
    }, {
      type: 'COMMIT'
    }, {
      type: 'BLUR'
    }]);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [!props.isLabelHidden && /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: /*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          children: [(_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : name, ' ', props.required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      })
    }), /*#__PURE__*/_jsx(ContextualMenuSelect, {
      items: value !== null && value !== void 0 ? value : [],
      onChange: handleChange
    }), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};